import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../utils/api';

const DAYS = ['الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'];

const TRANSPORT_SLOTS = [
    { key: 'm_in_0800',  period: 'morning',   type: 'in',  label: '08H00', sub: 'دخول' },
    { key: 'm_in_0900',  period: 'morning',   type: 'in',  label: '09H00', sub: 'دخول' },
    { key: 'm_in_1000',  period: 'morning',   type: 'in',  label: '10H00', sub: 'دخول' },
    { key: 'm_out_1000', period: 'morning',   type: 'out', label: '10H00', sub: 'خروج' },
    { key: 'm_out_1100', period: 'morning',   type: 'out', label: '11H00', sub: 'خروج' },
    { key: 'm_out_1200', period: 'morning',   type: 'out', label: '12H00', sub: 'خروج' },
    { key: 'a_in_1400',  period: 'afternoon', type: 'in',  label: '14H00', sub: 'دخول' },
    { key: 'a_in_1500',  period: 'afternoon', type: 'in',  label: '15H00', sub: 'دخول' },
    { key: 'a_in_1600',  period: 'afternoon', type: 'in',  label: '16H00', sub: 'دخول' },
    { key: 'a_out_1600', period: 'afternoon', type: 'out', label: '16H00', sub: 'خروج' },
    { key: 'a_out_1700', period: 'afternoon', type: 'out', label: '17H00', sub: 'خروج' },
    { key: 'a_out_1800', period: 'afternoon', type: 'out', label: '18H00', sub: 'خروج' },
];

export const TimetablePrint = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [reportData, setReportData] = useState(null);
    const [selectedLevel, setSelectedLevel] = useState('college'); // 'college' (الإعدادي - الصورة) or 'all'
    const [selectedDay, setSelectedDay] = useState('all');
    const [selectedDouars, setSelectedDouars] = useState([]); // Array of selected douar keys, empty = all
    const [viewMode, setViewMode] = useState('douar_matrix'); // 'douar_matrix' (photo format) or 'class_matrix'
    const [academicYears, setAcademicYears] = useState([]);
    const [selectedAcademicYear, setSelectedAcademicYear] = useState('');

    useEffect(() => {
        const fetchYears = async () => {
            try {
                const res = await api.get('/academic-years?all=true');
                const years = Array.isArray(res.data) ? res.data : (res.data?.data || []);
                setAcademicYears(years);
            } catch (err) {
                console.error('Error fetching academic years', err);
            }
        };
        fetchYears();
    }, []);

    useEffect(() => {
        const fetchReport = async () => {
            setLoading(true);
            try {
                let url = `/timetables/douar-report?level=${selectedLevel}`;
                if (selectedAcademicYear) {
                    url += `&academic_year_id=${selectedAcademicYear}`;
                }
                const res = await api.get(url);
                setReportData(res.data);
            } catch (err) {
                console.error('Error loading timetable print report', err);
            } finally {
                setLoading(false);
            }
        };
        fetchReport();
    }, [selectedLevel, selectedAcademicYear]);

    if (loading) {
        return (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', fontFamily: 'Noto Kufi Arabic, sans-serif', direction: 'rtl' }}>
                <p style={{ color: '#64748b', fontSize: '14px' }}>جاري تحضير برنامج توقيت خروج التلاميذ...</p>
            </div>
        );
    }

    const { days, report, all_douars, transport_matrix, academic_year, total_students_count } = reportData || {
        days: DAYS, report: {}, all_douars: [], transport_matrix: {}, academic_year: '2027/2026', total_students_count: 0
    };

    const filteredDays = selectedDay === 'all' ? days : [selectedDay];
    const availableDouars = all_douars || [];

    // Toggle single douar selection in state
    const toggleDouar = (key) => {
        setSelectedDouars(prev => {
            if (prev.includes(key)) {
                return prev.filter(k => k !== key);
            } else {
                return [...prev, key];
            }
        });
    };

    const selectAllDouars = () => setSelectedDouars([]);
    const deselectAllDouars = () => setSelectedDouars(['__NONE__']);

    // Determine active douar keys to render
    let activeDouarKeys = [];
    if (selectedDouars.length === 0) {
        activeDouarKeys = availableDouars.map(d => d.key);
    } else if (selectedDouars.includes('__NONE__')) {
        activeDouarKeys = [];
    } else {
        activeDouarKeys = selectedDouars;
    }

    const handlePrint = () => window.print();

    return (
        <div className="timetable-print-wrapper" dir="rtl">

            {/* ── Print Controls (hidden on print) ── */}
            <div className="print-controls no-print">
                <div className="controls-right">
                    <button onClick={() => navigate('/dashboard/timetables')} className="btn-back">
                        ← العودة
                    </button>
                    <div className="controls-info">
                        <strong>برنامج توقيت النقل المدرسي</strong>
                        <span>تقرير الدواوير وعدد التلاميذ حسب التوقيت</span>
                    </div>
                </div>

                <div className="controls-filters">
                    {/* View Mode */}
                    <div className="filter-group">
                        <label>نوع التقرير:</label>
                        <select value={viewMode} onChange={e => setViewMode(e.target.value)}>
                            <option value="douar_matrix">جدول الدواوير والتوقيت (الشكل الرسمي)</option>
                            <option value="class_matrix">جدول استعمال الزمن للأقسام</option>
                        </select>
                    </div>

                    {/* Academic Year Filter */}
                    {academicYears.length > 0 && (
                        <div className="filter-group">
                            <label>السنة الدراسية:</label>
                            <select value={selectedAcademicYear} onChange={e => setSelectedAcademicYear(e.target.value)}>
                                <option value="">السنة الحالية</option>
                                {academicYears.map(y => (
                                    <option key={y.id} value={y.id}>{y.name}</option>
                                ))}
                            </select>
                        </div>
                    )}

                    {/* Level Filter */}
                    <div className="filter-group">
                        <label>المستوى:</label>
                        <select value={selectedLevel} onChange={e => setSelectedLevel(e.target.value)}>
                            <option value="college">سلك الإعدادي (مثل النموذج)</option>
                            <option value="all">جميع المستويات</option>
                        </select>
                    </div>

                    {/* Day Selector */}
                    <div className="filter-group">
                        <label>اليوم:</label>
                        <select value={selectedDay} onChange={e => setSelectedDay(e.target.value)}>
                            <option value="all">جميع الأيام</option>
                            {days.map(d => <option key={d} value={d}>{d}</option>)}
                        </select>
                    </div>

                    <button onClick={handlePrint} className="btn-print">🖨️ طباعة التقرير (PDF)</button>
                </div>

                {/* Douar Selector Bar */}
                {viewMode === 'douar_matrix' && (
                    <div className="douar-filter-bar">
                        <div className="douar-filter-label">
                            <strong>تصفية الدواوير:</strong>
                            <span>({activeDouarKeys.length} من {availableDouars.length} محدد)</span>
                        </div>
                        <div className="douar-quick-actions">
                            <button onClick={selectAllDouars} className={`btn-chip ${selectedDouars.length === 0 ? 'active' : ''}`}>
                                جميع الدواوير
                            </button>
                            <button onClick={deselectAllDouars} className="btn-chip btn-chip-reset">
                                إلغاء التحديد
                            </button>
                        </div>
                        <div className="douar-chips-list">
                            {availableDouars.map(d => {
                                const isSelected = selectedDouars.length === 0 || selectedDouars.includes(d.key);
                                return (
                                    <button
                                        key={d.key}
                                        type="button"
                                        onClick={() => toggleDouar(d.key)}
                                        className={`douar-chip ${isSelected ? 'selected' : ''}`}
                                    >
                                        <span className="chip-check">{isSelected ? '✓' : ''}</span>
                                        {d.name}
                                    </button>
                                );
                            })}
                        </div>
                    </div>
                )}
            </div>

            {/* ── Printable Document ── */}
            <div className="report-doc">

                {/* ── Header Matching Photo ── */}
                <div className="official-header">
                    <div className="header-right">
                        <div className="logo-box">
                            <img src="/logo.png" alt="شعار الجمعية" className="header-logo" onError={(e) => { e.target.style.display = 'none'; }} />
                            <div>
                                <p className="assoc-title">جمعية تنمية النقل المدرسي</p>
                                <p className="assoc-sub">بأولاد دحو</p>
                                <p className="assoc-fr">Association de Développement du Transport Scolaire</p>
                                <p className="assoc-fr-sub">Oulad Dahou</p>
                            </div>
                        </div>
                    </div>

                    <div className="header-center">
                        <h1 className="main-title">
                            برنامج توقيت خروج للتلاميذ المستفيدين من النقل المدرسي {selectedLevel === 'college' ? '(الإعدادي)' : '(جميع المستويات)'}
                        </h1>
                        <div className="academic-year-underlined">
                            {academic_year || '2027/2026'}
                        </div>
                    </div>
                </div>

                {/* ── Douar Transport Matrix View (Matching Photo) ── */}
                {viewMode === 'douar_matrix' && (
                    <div className="table-wrapper">
                        <table className="official-transport-table">
                            <thead>
                                {/* Row 1: Headers */}
                                <tr>
                                    <th rowSpan={3} className="th-col-douar">العنوان</th>
                                    <th rowSpan={3} className="th-col-day">الأيام</th>
                                    <th colSpan={12} className="th-col-time">التوقيت</th>
                                </tr>
                                {/* Row 2: Periods */}
                                <tr>
                                    <th colSpan={6} className="th-period morning">الفترة الصباحية</th>
                                    <th colSpan={6} className="th-period afternoon">الفترة المسائية</th>
                                </tr>
                                {/* Row 3: Slots with In/Out */}
                                <tr>
                                    {TRANSPORT_SLOTS.map(slot => (
                                        <th key={slot.key} className={`th-slot ${slot.type}`}>
                                            <div className="slot-label">{slot.label}</div>
                                            <div className="slot-sub">{slot.sub}</div>
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {activeDouarKeys.length === 0 ? (
                                    <tr>
                                        <td colSpan={14} className="no-data-cell">
                                            لم يتم اختيار أي دوار للطباعة
                                        </td>
                                    </tr>
                                ) : (
                                    activeDouarKeys.map(dKey => {
                                        const dData = transport_matrix[dKey];
                                        const douarName = dData?.douar_name || dKey;
                                        const daysMap = dData?.days || {};

                                        return filteredDays.map((day, dayIdx) => {
                                            const daySlots = daysMap[day] || {};
                                            const isLastDay = dayIdx === filteredDays.length - 1;
                                            return (
                                                <tr key={`${dKey}-${day}`} className={isLastDay ? 'tr-douar-last-day' : ''}>
                                                    {/* Douar Name cell spans rows for filtered days */}
                                                    {dayIdx === 0 && (
                                                        <td rowSpan={filteredDays.length} className="td-douar-name">
                                                            {douarName}
                                                        </td>
                                                    )}

                                                    {/* Day Name */}
                                                    <td className="td-day-name">{day}</td>

                                                    {/* 12 Time slots count cells */}
                                                    {TRANSPORT_SLOTS.map(slot => {
                                                        const count = daySlots[slot.key] || 0;
                                                        return (
                                                            <td key={slot.key} className={`td-count-cell ${count > 0 ? 'has-count' : ''}`}>
                                                                {count > 0 ? count : ''}
                                                            </td>
                                                        );
                                                    })}
                                                </tr>
                                            );
                                        })
                                    })
                                )}
                            </tbody>
                        </table>
                    </div>
                )}

                {/* ── Class Matrix View (Fallback / Alternative View) ── */}
                {viewMode === 'class_matrix' && (
                    <div className="table-wrapper">
                        <table className="matrix-table">
                            <thead>
                                <tr>
                                    <th className="th-day">اليوم</th>
                                    <th>8 إلى 9</th>
                                    <th>9 إلى 10</th>
                                    <th>10 إلى 11</th>
                                    <th>11 إلى 12</th>
                                    <th>12 إلى 13</th>
                                    <th>13 إلى 14</th>
                                    <th>14 إلى 15</th>
                                    <th>15 إلى 16</th>
                                    <th>16 إلى 17</th>
                                    <th>17 إلى 18</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredDays.map((day, idx) => {
                                    const daySlots = report[day] || [];
                                    if (daySlots.length === 0) {
                                        return (
                                            <tr key={day} className={idx % 2 === 0 ? 'row-even' : 'row-odd'}>
                                                <td className="td-day">{day}</td>
                                                {Array.from({ length: 10 }).map((_, i) => (
                                                    <td key={i} className="empty-cell">—</td>
                                                ))}
                                            </tr>
                                        );
                                    }
                                    return daySlots.map((slot, sIdx) => (
                                        <tr key={`${day}-${sIdx}`} className={idx % 2 === 0 ? 'row-even' : 'row-odd'}>
                                            {sIdx === 0 && <td className="td-day" rowSpan={daySlots.length}>{day}</td>}
                                            <td colSpan={10} className="data-cell">
                                                <strong>{slot.classes.join(', ')}</strong> ({slot.start_time} - {slot.end_time}) — إجمالي: {slot.total_students} تلميذ
                                            </td>
                                        </tr>
                                    ));
                                })}
                            </tbody>
                        </table>
                    </div>
                )}

                {/* Footer Signatures */}
                <div className="doc-footer">
                    <div className="sign-box">
                        <p className="sign-label">توقيع إدارة الجمعية</p>
                        <div className="sign-line"></div>
                    </div>
                    <div className="sign-box">
                        <p className="sign-label">توقيع سائق الحافلة</p>
                        <div className="sign-line"></div>
                    </div>
                </div>
            </div>

            {/* ── Scoped CSS Styles ── */}
            <style dangerouslySetInnerHTML={{ __html: `
                @import url('https://fonts.googleapis.com/css2?family=Noto+Kufi+Arabic:wght@400;600;700;800;900&display=swap');

                * { box-sizing: border-box; margin: 0; padding: 0; }

                .timetable-print-wrapper {
                    font-family: 'Noto Kufi Arabic', sans-serif;
                    direction: rtl;
                    background: #f1f5f9;
                    min-height: 100vh;
                    padding-bottom: 40px;
                }

                /* ── Controls bar ── */
                .print-controls {
                    background: #ffffff;
                    border-bottom: 1px solid #cbd5e1;
                    padding: 16px 24px;
                    display: flex;
                    flex-direction: column;
                    gap: 14px;
                    position: sticky;
                    top: 0;
                    z-index: 100;
                    box-shadow: 0 2px 8px rgba(0,0,0,0.08);
                }

                .controls-right { display: flex; align-items: center; gap: 16px; }
                .controls-info { display: flex; flex-direction: column; gap: 2px; }
                .controls-info strong { font-size: 15px; color: #0f172a; font-weight: 800; }
                .controls-info span { font-size: 12px; color: #64748b; }

                .controls-filters {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    gap: 16px;
                    flex-wrap: wrap;
                }

                .filter-group { display: flex; align-items: center; gap: 8px; font-size: 13px; color: #334155; font-weight: 600; }
                .filter-group select {
                    border: 1px solid #cbd5e1;
                    border-radius: 8px;
                    padding: 6px 12px;
                    font-size: 13px;
                    font-family: inherit;
                    color: #0f172a;
                    background: #f8fafc;
                    outline: none;
                    font-weight: 600;
                }

                .btn-back {
                    border: 1px solid #cbd5e1;
                    background: #ffffff;
                    color: #475569;
                    padding: 8px 16px;
                    border-radius: 8px;
                    font-size: 13px;
                    font-family: inherit;
                    cursor: pointer;
                    font-weight: 700;
                    transition: all 0.2s;
                }
                .btn-back:hover { border-color: #eea508; color: #eea508; }

                .btn-print {
                    background: #eea508;
                    color: #ffffff;
                    border: none;
                    padding: 9px 22px;
                    border-radius: 8px;
                    font-size: 13px;
                    font-family: inherit;
                    cursor: pointer;
                    font-weight: 800;
                    box-shadow: 0 2px 6px rgba(238, 165, 8, 0.3);
                    transition: background 0.2s;
                }
                .btn-print:hover { background: #d99100; }

                /* Douar filter bar */
                .douar-filter-bar {
                    background: #f8fafc;
                    border: 1px solid #e2e8f0;
                    border-radius: 10px;
                    padding: 12px 16px;
                    display: flex;
                    flex-direction: column;
                    gap: 10px;
                }

                .douar-filter-label {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    font-size: 13px;
                    color: #1e293b;
                }
                .douar-filter-label span { color: #eea508; font-weight: 700; font-size: 12px; }

                .douar-quick-actions { display: flex; align-items: center; gap: 8px; }

                .btn-chip {
                    border: 1px solid #cbd5e1;
                    background: #fff;
                    color: #475569;
                    padding: 4px 12px;
                    border-radius: 6px;
                    font-size: 11px;
                    font-family: inherit;
                    cursor: pointer;
                    font-weight: 700;
                    transition: all 0.15s;
                }
                .btn-chip.active { background: #1e293b; color: #fff; border-color: #1e293b; }
                .btn-chip-reset:hover { border-color: #ef4444; color: #ef4444; }

                .douar-chips-list {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 6px;
                    max-height: 120px;
                    overflow-y: auto;
                }

                .douar-chip {
                    display: inline-flex;
                    align-items: center;
                    gap: 5px;
                    padding: 5px 12px;
                    border-radius: 20px;
                    border: 1px solid #cbd5e1;
                    background: #ffffff;
                    color: #475569;
                    font-size: 12px;
                    font-family: inherit;
                    cursor: pointer;
                    font-weight: 600;
                    transition: all 0.15s;
                }
                .douar-chip:hover { border-color: #eea508; color: #eea508; }
                .douar-chip.selected {
                    background: #fff7ed;
                    border-color: #eea508;
                    color: #c2410c;
                    font-weight: 800;
                }
                .chip-check { font-size: 11px; font-weight: 900; }

                /* ── Printable Document Container ── */
                .report-doc {
                    max-width: 1100px;
                    margin: 24px auto;
                    background: #ffffff;
                    border: 2px solid #1e293b;
                    border-radius: 4px;
                    padding: 24px;
                    box-shadow: 0 4px 16px rgba(0,0,0,0.06);
                }

                /* ── Official Header ── */
                .official-header {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    border-bottom: 2px solid #000000;
                    padding-bottom: 12px;
                    margin-bottom: 16px;
                }
                .header-right { text-align: right; }
                .assoc-title { font-size: 14px; font-weight: 900; color: #000000; line-height: 1.2; }
                .assoc-sub { font-size: 13px; font-weight: 800; color: #000000; }

                .header-center { text-align: center; flex: 1; padding: 0 16px; }
                .main-title {
                    font-size: 15px;
                    font-weight: 900;
                    color: #000000;
                    line-height: 1.3;
                }
                .academic-year-underlined {
                    font-size: 14px;
                    font-weight: 900;
                    color: #000000;
                    text-decoration: underline;
                    margin-top: 4px;
                }

                .header-left { text-align: left; }
                .logo-box { display: flex; align-items: center; gap: 8px; }
                .header-logo { width: 50px; height: 50px; object-fit: contain; }
                .assoc-fr { font-size: 9px; font-weight: 700; color: #000000; line-height: 1.1; }
                .assoc-fr-sub { font-size: 9px; font-weight: 800; color: #000000; }

                /* ── Official Transport Table Layout (Exact photo match) ── */
                .official-transport-table {
                    width: 100%;
                    border-collapse: collapse;
                    font-size: 12px;
                    text-align: center;
                    border: 2px solid #000000;
                }

                .official-transport-table th,
                .official-transport-table td {
                    border: 1.5px solid #000000;
                    color: #000000;
                    padding: 4px 6px;
                }

                .tr-douar-last-day td {
                    border-bottom: 2.5px solid #000000 !important;
                }

                .th-col-douar { width: 140px; font-size: 14px; font-weight: 900; background: #ffffff; }
                .th-col-day { width: 90px; font-size: 14px; font-weight: 900; background: #ffffff; }
                .th-col-time { font-size: 15px; font-weight: 900; background: #ffffff; }

                .th-period {
                    font-size: 13px;
                    font-weight: 900;
                    background: #ffffff;
                }

                .th-slot {
                    font-size: 12px;
                    font-weight: 900;
                    background: #ffffff;
                    padding: 3px;
                    min-width: 55px;
                }
                .slot-label { font-size: 11px; font-weight: 900; }
                .slot-sub { font-size: 11px; font-weight: 900; color: #000000; margin-top: 1px; }

                .td-douar-name {
                    font-weight: 900;
                    font-size: 14px;
                    vertical-align: middle !important;
                    background: #ffffff;
                }

                .td-day-name {
                    font-weight: 800;
                    font-size: 13px;
                    vertical-align: middle !important;
                    background: #ffffff;
                }

                .td-count-cell {
                    font-weight: 900;
                    font-size: 14px;
                    vertical-align: middle !important;
                    min-height: 32px;
                }
                .td-count-cell.has-count {
                    font-weight: 900;
                    font-size: 15px;
                    color: #000000;
                }

                .no-data-cell {
                    padding: 30px;
                    font-size: 14px;
                    color: #64748b;
                    text-align: center;
                }

                /* ── Class Matrix Fallback ── */
                .matrix-table {
                    width: 100%;
                    border-collapse: collapse;
                    font-size: 11px;
                    border: 2px solid #000000;
                }
                .matrix-table th, .matrix-table td {
                    border: 1px solid #000000;
                    padding: 6px;
                    text-align: center;
                }

                /* ── Footer ── */
                .doc-footer {
                    display: flex;
                    justify-content: space-around;
                    margin-top: 32px;
                    padding-top: 16px;
                }
                .sign-box { text-align: center; }
                .sign-label { font-size: 12px; font-weight: 900; color: #000000; }
                .sign-line { border-top: 1px solid #000000; width: 140px; margin: 24px auto 0; }

                /* ── Print Media Styles ── */
                @media print {
                    @page {
                        size: A4 landscape;
                        margin: 6mm;
                    }

                    .no-print { display: none !important; }

                    .timetable-print-wrapper {
                        background: #ffffff;
                        padding: 0;
                        min-height: auto;
                    }

                    .report-doc {
                        margin: 0;
                        border: none;
                        border-radius: 0;
                        padding: 0;
                        max-width: 100%;
                        box-shadow: none;
                    }

                    .official-header {
                        padding-bottom: 6px !important;
                        margin-bottom: 10px !important;
                        border-bottom: 2px solid #000000 !important;
                    }

                    .assoc-title { font-size: 12px !important; color: #000 !important; }
                    .assoc-sub { font-size: 11px !important; color: #000 !important; }
                    .main-title { font-size: 14px !important; color: #000 !important; }

                    .official-transport-table {
                        border: 2px solid #000000 !important;
                        width: 100% !important;
                    }

                    .official-transport-table th,
                    .official-transport-table td {
                        border: 1.5px solid #000000 !important;
                        color: #000000 !important;
                        padding: 3px 4px !important;
                        font-size: 11px !important;
                    }

                    .th-col-douar, .th-col-day { font-size: 12px !important; }
                    .th-col-time { font-size: 13px !important; }
                    .slot-label { font-size: 10px !important; }
                    .slot-sub { font-size: 10px !important; }
                    .td-douar-name { font-size: 12px !important; }
                    .td-day-name { font-size: 11px !important; }
                    .td-count-cell { font-size: 13px !important; }

                    .doc-footer {
                        margin-top: 20px !important;
                        padding-top: 10px !important;
                    }
                    .sign-label { font-size: 11px !important; }
                    .sign-line { margin: 18px auto 0 !important; }

                    body {
                        -webkit-print-color-adjust: exact !important;
                        print-color-adjust: exact !important;
                        color: #000000 !important;
                    }
                }
            `}} />
        </div>
    );
};
